import React from "react";
import classes from './DesktopCategoryFilter.module.css';
import Dropdown from "./../../Global/customDropdown/Dropdown";

const DesktopCategoryFilter = (props) => {

    const filterCategory = ["All","Influencer Curated","International Experiences","Weekend Getaway","Mindful Retreat"]
    const selectedCategory = props?.selectedCategory || "All";

    return (
        <>
        {/* Filter for trip cards */}
        <div className={classes['trip-filter']} >

            <div className={classes['filter-buttons-container']} >
                {
                    filterCategory.map((fc,index) => {
                        return (
                            <button onClick={()=>{props.tripDataHandler(fc)}} style={{backgroundColor:`${selectedCategory===fc ? "#e65439":""}`,color:`${selectedCategory===fc ? "white":""}`}} className={classes['filter-buttons']}>{fc}</button>
                        )
                    })
                }
                {/* <button onClick={()=>{props.tripDataHandler('All')}} style={{backgroundColor:" "}} className={classes['filter-buttons']}>All</button>
                <button onClick={()=>{props.tripDataHandler('Influencer Curated')}} style={{backgroundColor:" "}} className={classes['filter-buttons']}>Influencer Curated</button>
                <button onClick={()=>{props.tripDataHandler('International Experiences')}} style={{backgroundColor:" "}} className={classes['filter-buttons']}>International Experiences</button>
                <button onClick={()=>{props.tripDataHandler("Weekend Getaway")}} style={{backgroundColor:" "}} className={classes['filter-buttons']}>Weekend Getaways</button>
                <button onClick={()=>{props.tripDataHandler("Mindful Retreat")}} style={{backgroundColor:" "}} className={classes['filter-buttons']}>Mindful Retreats</button> */}
            </div>
            <div className={classes['month-dropdown-adjust']}>
                <Dropdown options={props.dropdownOptions} tripDataHandler={props.tripMonthHandler} plc={'Select Month'} />
            </div>
        </div>
        </>
    )
};

export default DesktopCategoryFilter;